import { Role } from './role';
import { User } from './user';

export class UserRoles {
  public id: number;
  public roleId: number;
  public role: Role;
  public userId: number;
  public user: User;
}